<div
    class="incident"
    role="button"
    tabindex="0"
    [class.inTimeline]="inTimeline()"
    [id]="incident().id"
    (click)="onIncidentClick()"
    (keydown)="onKeyDown($event)"
>
    <div class="incident-detail"><b>Service:</b> {{ incident().service }}</div>
    <div class="incident-detail"><b>Started:</b> {{ incident().startedAt }}</div>
    <div class="incident-detail"><b>Severity:</b> {{ incident().severity }}</div>
    <div class="incident-detail"><b>Reporter:</b> {{ incident().reporter }}</div>
    <div class="incident-detail"><b>Status:</b> {{ capitalize(incident().status) }}</div>
    <div class="incident-detail">
        <b>Description:</b>
        <div class="description">{{ incident().description }}</div>
    </div>
    @if (incident().log.length && !inTimeline()) {
        <div class="incident-detail update-log">
            <b>Updates:</b>
            @for (log of incident().log; track log.timestamp) {
                <div class="log">
                    {{ log.timestamp }}:
                    {{ log.text }}
                </div>
            }
        </div>
    }
</div>
